<template>
  <div class="page-content">

    <!-- 角色搜索以及添加栏目 -->
    <div class="product-menu">
      <div class="left">
        <el-button  type="primary" class="first-btn" @click="addTemplate" style="margin-bottom: 10px; font-size: 14px;">添加角色模板</el-button>
      </div>
      <div class="product-menu">
        <div style="display:flex;margin-right:20px">
          <el-input v-model="organizationType" placeholder="请输入组织类型" ></el-input>
          <el-button type="primary" icon="el-icon-search" @click="selOrg" style="margin-bottom: 10px"></el-button>
        </div>
        <div style="display:flex">
          <el-input v-model.trim="roleName" placeholder="请输入角色名称" ></el-input>
          <el-button type="primary" icon="el-icon-search" @click="sel" style="margin-bottom: 10px"></el-button>
        </div>
      </div>
    </div>

    <!-- 数据展示区域 -->
    <div class="dataList">
      <el-table
        ref="multipleTable"
        border
        :cell-style="cellStyle"
        :header-cell-style="headCellStyle"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%">
        <el-table-column
         prop="roleName"
          label="角色名称">
        </el-table-column>
        <el-table-column
          prop="organizationType"
          label="组织类型">
          <template slot-scope="scope">
            <span>{{scope.row.organizationType.toString() === '2'?'厂商':'管理平台'}}</span>
            <!-- <span v-if="scope.row.organizationType === 2">厂商</span>
            <span v-else>医院</span> -->
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          >
          <template slot-scope="scope">
             <div class="opreationBtn">
              <span class="check" @click="handlerClick('view',scope.row)">查看</span>
               <span class="edit" @click="handlerClick('edit',scope.row)">编辑</span>
              <span class="del"  @click="handlerClick('del',scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
      <el-row
        v-show="!listLoading"
        class="pagination-container"
        type="flex" justify="end"
        >
        <!-- 页码按钮的数量currenCurrent  sizeChange -->
        <el-pagination
          :current-page.sync="listQuery.page"
          :page-sizes="[10,15,20,25, 30]"
          :page-size="listQuery.limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"/>
      </el-row>
    <roleTemplateView
      v-if="dialogView"
      @updateList="getList"
      :viewData="viewData"
      :editType="editType"
      :dialogView="dialogView"
      @closeDialog="dialogView = false"/>
  </div>
</template>
<script>
import { roleTemplateList, delRoleTemplate } from '@/api/auth'
import roleTemplateView from '@/components/template/roleTemplateView'
export default {
  components: {
    roleTemplateView
  },
  data () {
    return {
      cellStyle: { 'text-align': 'center' },
      headCellStyle: { 'text-align': 'center', 'font-weight': 'bold', 'font-size': '17px', color: 'black', 'background-color': '#f4f5f7' },
      // 分页功能
      total: 0, // 到时候从后台获取
      listLoading: false, // 根据loading来进行显示/隐藏
      listQuery: {
        page: 1,
        limit: 10
      },
      tableData: [],
      dialogView: false,
      viewData: null,
      editType: '',
      roleName: '',
      organizationType: ''
    }
  },
  created () {
    // 获取角色列表
    this.getList()
  },
  methods: {
    sel () {
      this.getList()
    },
    selOrg () {
      this.getList()
    },
    handlerClick (sty, row) {
      switch (sty) {
        case 'view':
          this.editType = sty
          this.viewData = Object.assign({}, row)
          this.dialogView = true
          break
        case 'edit':
          this.editType = sty
          this.viewData = Object.assign({}, row)
          this.dialogView = true
          break
        case 'del':
          this.$confirm('确定删除此角色?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => {
            console.log('确定删除')
            this.dleTemplate(row)
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
          break
        default:
          break
      }
    },
    dleTemplate (row) {
      delRoleTemplate(row.roleTemplateId).then(res => {
        res = res.data
        if (res.code === 0 || res.code === 200) {
          this.$message({
            type: 'success',
            message: '删除成功'
          })
          this.getList()
        }
      })
    },
    // 分页管理
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.organizationType = ''
      this.roleName = ''
      this.getList()
    },
    // 改变页码
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getList()
    },
    getList () {
      const reg = /^[0-9]*$/
      let org = this.organizationType
      if (!reg.test(org)) {
        if (org === '厂商') {
          org = 2
        } else if (org === '管理平台') {
          org = 0
        } else {
          org = 1
        }
      }
      const params = {
        pageNumber: this.listQuery.page,
        pageSize: this.listQuery.limit,
        roleName: this.roleName,
        organizationType: org
      }
      roleTemplateList(params).then(res => {
        res = res.data
        console.log(res)
        if (res.data.total <= 5) this.listLoading = true
        this.total = res.data.total
        this.tableData = res.data.list
      })
    },
    addTemplate () {
      this.editType = 'add'
      this.viewData = null
      this.dialogView = true
    }
  }
}
</script>
<style lang="less" scoped>
.product-menu{
  display: flex;
  justify-content: space-between;
}
.page-content{
  .dataList{
    margin-top: 10px;
    margin-bottom: 20px;
      background-color: white;
      .opreationBtn{
        .check{
          color: #35a6df;
          cursor: pointer;
        }
        .edit{
          color: #35a6df;
          cursor: pointer;
        }
        .del{
          color: red;
          cursor: pointer;
        }
        span{
          margin-left: 20px;
        }
      }
      .showAll{
        display: flex;
        align-items: center;
        span{
          color: #f0bd95;
        }
      }
      .dataListOperation{
        padding:20px;
      }
    }
}
</style>
